var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56397 0.965772C5.74363 0.606462 6.25638 0.606461 6.43604 0.965769L8.40998 4.91365L11.2455 3.02329C11.6069 2.78237 12.0791 3.09864 11.994 3.52452L10.9165 8.91165C10.871 9.13953 10.6709 9.30355 10.4385 9.30355H1.56151C1.32913 9.30355 1.12905 9.13952 1.08348 8.91165L0.00605358 3.52452C-0.0791222 3.09864 0.393127 2.78238 0.754499 3.02329L3.59004 4.91365L5.56397 0.965772Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Crown.43734a8074426a1186ba67509c777d29.svg";